import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const ListView = (props) => {
    return (React.createElement(ListViewStyled, { withSubMenu: props.withSubMenu }, props.items));
};
export default ListView;
const ListViewStyled = styled.div `
  margin-top: -${THEME.GRID_SPACING}px;
  width: 25%;
  position: absolute;
  left: 0;
  height: ${(props) => `calc(100vh - ${props.withSubMenu
    ? THEME.NAV_TOP_HEIGHT + THEME.SUB_MENU_HEIGHT
    : THEME.NAV_TOP_HEIGHT}px);`}
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  & > div {
    & > h1 {
      margin: 0;
      font-size: 0.6em;
    }
    & > p {
      margin: 5px 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
//# sourceMappingURL=ListView.js.map